import { useContext } from "react";
import { ShopContext } from "./ShpContext";

export default function useShop() {
  return useContext(ShopContext);
}
